<template>
    <RetryPricePlansImportForm
        submit-route="products.plans.import.retry"
        show-route="products.product-addons.plans.import.retry.show"
        cancel-route-name="products.product-addons.download-upload"
        :product-plan-import="productPlanImport"
        :import-errors="importErrors"
        :errors="errors"
    />
</template>

<script setup>
import RetryPricePlansImportForm from '~@/Components/Products/Products/RetryPricePlansImportForm.vue'

defineProps({
    productPlanImport: { type: Object, required: true },
    importErrors: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
})
</script>
